/* eslint-disable no-unused-expressions */

import { Component } from "react";
import { withTranslation } from "react-i18next";
import sysJwt from "../../../utils/sysJwt";
import { post } from "../../../utils/sysAxios";
import { confirmAlert } from "react-confirm-alert";
import SysTable from "../../commonComponents/SysTable";

class PayMethod extends Component {
  state = {

    contentHeader: "Payment Methods",

    dataUrl: "/api/data/getpaymethods",
    activateUrl: "/api/data/Activatepaymethod",
    deactivateUrl: "/api/data/Deactivatepaymethod",

    tableData: [],
  };

  componentDidMount() {
    this.getData();
  }

  getData() {
    post(this.state.dataUrl, null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({ tableData: apiResponse.data.respData.data });
      }
    );
  }

  handleActivate(row) {
    confirmAlert({
      title: "Activate Payment Method",
      message: this.props.t("dialog.deleteConfirm"),
      buttons: [
        { label: this.props.t("btn.yes"),
          onClick: () => {
            post(
              this.state.activateUrl,
              { id: row.ID },
              this.props.updateIsLoading
            ).then((apiResponse) => {
              apiResponse.data.respCode === 0 ? this.getData() : null;
            });
          },
        },
        { label: this.props.t("btn.cancel"),
          onClick: () => null,
        },
      ],
    });
  }

  handleDeactivate(row) {
    confirmAlert({
      title: "Deactivate Payment Method",
      message: this.props.t("dialog.deleteConfirm"),
      buttons: [
        { label: this.props.t("btn.yes"),
          onClick: () => {
            post(
              this.state.deactivateUrl,
              { id: row.ID },
              this.props.updateIsLoading
            ).then((apiResponse) => {
              apiResponse.data.respCode === 0 ? this.getData() : null;
            });
          },
        },
        { label: this.props.t("btn.cancel"),
          onClick: () => null,
        },
      ],
    });
  }

  getColumns() {
    const { t } = this.props;
    return [
      {
        id: 1,
        label: t("col.englishPayMethod"),
        field: "METHOD_AR",
      },
      {
        id: 2,
        label: t("col.arabicPayMethod"),
        field: "METHOD_EN",
      },
      {
        id: 3,
        label: t("col.kurdishPayMethod"),
        field: "METHOD_KU",
      },
      {
        id: 4,
        label: t("col.isActive"),
        field: "IS_ACTIVE",
        cellRenderer: ({ data }) => {
          return data.IS_ACTIVE ? "Yes" : "No";
        },
      },
      {
        id: 5,
        label: t("col.actions"),
        field: "SYS_ACTINOS",
        width: "100px",
        maxResizeWidth: "100px",
        resizable: false,
        pinned: true,
        cellRenderer: ({ data }) => {
          return (
            <div id="outer">
              {sysJwt.isAuthorized(["CB74"]) && (
                <div className="inner" title="Activate">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => this.handleActivate(data)}
                  >
                    <i className="fa fa-check" />
                  </button>
                </div>
              )}
              {sysJwt.isAuthorized(["CB75"]) && (
                <div className="inner" title="Deactivate">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => this.handleDeactivate(data)}
                  >
                    <i className="fa fa-ban" />
                  </button>
                </div>
              )}
            </div>
          );
        },
      },
    ];
  }

  render() {
    const { t } = this.props;
    return (
      <div className="bms-content-component fade-in">
        <div className="row">
          <div className="col">
            <h4>{t("pages.paymentMethods")}</h4>
          </div>
          <div className="col flex-container-left">
          </div>
        </div>
        <hr />
        <SysTable
          columns={this.getColumns()}
          rows={this.state.tableData}
          pageSizes={[10, 15, 20, 25, 30]}
        />
      </div>
    );
  }
}

export default withTranslation()(PayMethod);
